/* @flow */
/**
 * AudioSupport is used to determine if a file's content type can be played with
 * the HTML5 <audio> tag within a browser.
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Supported_media_formats#Browser_compatibility
 */
import enumerate from 'lib/enumerate';
import userAgent from 'lib/currentUserAgent';
import { TYPES as DISALLOWED_TYPES } from 'lib/VideoSupport';

export const TYPES = enumerate([
  'audio/mp4',
  'audio/ogg',
  'audio/wav',
  'audio/webm',
]);

const TESTS = {
  'audio/mp4': 'audio/mp4; codecs="mp4a.40.5"',
  'audio/ogg': 'audio/ogg; codecs="vorbis"',
  'audio/wav': 'audio/wav; codecs="1"',
  'audio/webm': 'audio/webm; codecs="vorbis"',
};

const support = {};
let elem;

export function isSupportedType(type: string): boolean {
  if (userAgent.ie()) {
    return false;
  }

  if (type in support) {
    return support[type];
  }

  if (type in DISALLOWED_TYPES) {
    return false;
  }

  if (!elem) {
    // FIXME how to test this server side?
    if (typeof document === 'undefined') {
      return false;
    }
    elem = document.createElement('audio');
  }

  return (
    support[type] = typeof elem.canPlayType === 'function' ?
      !!elem.canPlayType(TESTS[type] || type).replace(/^no$/, '') :
      false
  );
}



// WEBPACK FOOTER //
// ./src/lib/AudioSupport.js